import React from "react";
import { Badge, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import orderPending from "../../../../../images/file.png";
import orderCancel from "../../../../../images/cancelOrder.png";
import orderCompleted from "../../../../../images/delivery.png";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";

const Item = ({ item, moduleConfig }) => {
  const getOrderStatusBadge = (status) => {
    if (status === "0" || status === 0)
      return (
        <badge
          bg="warning"
          className="font-small badge badge-pill badge-custom-8 text-dark"
        >
          Processing
        </badge>
      );
    if (status === "1" || status === 1)
      return (
        <badge
          bg="success"
          className="font-small badge  badge-pill badge-custom-7"
        >
          Completed
        </badge>
      );
    if (status === "2" || status === 2)
      return (
        <badge
          bg="danger"
          className="font-small badge badge-pill badge-custom-3"
        >
          Cancelled
        </badge>
      );
    return (
      <badge bg="secondary" className="font-small badge badge-custom-1">
        Unknown
      </badge>
    );
  };

  const getPaymentBadge = (status) => (
    <Badge bg={status ? "success" : "warning"} className="badge-pill">
      {status ? "Paid" : "Pending"}
    </Badge>
  );

  const getOrderImage = () => {
    if (item.orderStatus === "0") return orderPending;
    if (item.orderStatus === "2") return orderCancel;
    return orderCompleted;
  };

  return (
    <tr className="align-middle">
      <td className="p-2">
        <Image
          src={getOrderImage()}
          rounded
          width={32}
          height={32}
          className="object-fit-contain"
        />
      </td>
      <td className=" font-mono">{item.orderId}</td>
      <td className="text-truncate d-flex flex-column">
        {item?.checkoutType?.toLowerCase() === "member" ? (
          <Link to={`/customers/${item.customer?._id}`}>
            <p className="mb-0">{item.customer?.fullName || "-"}</p>
            <p className="mb-0 text-custom-4 text-muted">
              {item?.checkoutType}
            </p>
          </Link>
        ) : (
          <div>
            <p className="mb-0">{item.customer?.fullName || "-"}</p>
            <p className="mb-0 text-custom-4 text-muted">
              {item?.checkoutType}
            </p>
          </div>
        )}
      </td>
      <td className="text-center">{item.numberOfProducts || 0}</td>
      <td className="fw-bold text-custom-2">
        {item.totalAmount ? `${item.totalAmount} ${getCurrencyCode()}` : "-"}
      </td>
      <td className="text-center">{getPaymentBadge(item.payment?.status)}</td>
      <td className="text-nowrap font-small font-italic">
        {item.createdAt ? <ModuleDisplayDate value={item.createdAt} /> : "-"}
      </td>
      <td className="text-center">{getOrderStatusBadge(item.orderStatus)}</td>

      <td className="text-center p-2">
        <Link
          to={`/${moduleConfig.url}/${item._id}`}
          className="btn btn-outline-secondary btn-sm"
          title={`View ${moduleConfig.singleItemTitle}`}
        >
          <i className="fas fa-eye" />
        </Link>
      </td>
    </tr>
  );
};

export default Item;
